<div class="d-flex">
  <div class="row setting-card-container mx-auto">
    <mat-card class="mat-elevation-z4 w-100">
      <mat-card-title>Einstellungen</mat-card-title>
      <mat-card-content>
        <mat-tab-group>
          <mat-tab label="Tage">
            <div class="container-fluid p-1">
              <div class="row w-100 m-0">
                <div class="col-sm-12 col-md-4 p-0">
                  <h2>Tage</h2>
                  <small
                    >Legen Sie fest, nach wie vielen Tagen ein erfasstes Mandat als überfällig betrachtet werden
                    soll. Für Anzeige und BOM können unterschiedliche Tage eingestellt werden. (0 = sofort überfällig)</small
                  >
                </div>
                <div class="col-sm-12 col-md-7 offset-md-1 p-1">
                  <form class="mt-3" name="frmVSTVSettings" [formGroup]="frmVSettings">
                    <table class="table table-striped table-sm">
                      <tr>
                        <td class="bold">Anzeige — Anzahl Tage:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            id="TAGE_ZUR_ANZEIGE"
                            formControlName="TAGE_ZUR_ANZEIGE"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">BOM — Anzahl Tage:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            id="TAGE_ZUR_BOM"
                            formControlName="TAGE_ZUR_BOM"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="0" />
                        </td>
                      </tr>
                    </table>
                    <button mat-raised-button (click)="saveSettings()" color="primary">Speichern</button>
                  </form>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="VSTV">
            <div class="container-fluid p-1">
              <div class="row w-100 m-0">
                <div class="col-sm-12 col-md-4 p-0">
                  <h2>VSTV Export</h2>
                  <small>Informationen zum VSTV-Export</small>
                </div>
                <div class="col-sm-12 col-md-7 offset-md-1 p-1">
                  <form class="mt-3" name="frmVSTVSettings" [formGroup]="frmVSettings">
                    <table class="table table-striped table-sm">
                      <tr>
                        <td class="bold">Empfanger:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            id="EMPFANGER"
                            formControlName="EMPFANGER"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">Sender:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            id="SENDER"
                            formControlName="SENDER"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">Gemeinde:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            id="GEMEINDE"
                            formControlName="GEMEINDE"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">Tatortart:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            id="TATORTART"
                            formControlName="TATORTART"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">Landeskennzeichen:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            id="LANDESKENNZEICHEN"
                            formControlName="LANDESKENNZEICHEN"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">Wahrnehmung:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            id="WAHRNEHMUNG"
                            formControlName="WAHRNEHMUNG"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="" />
                        </td>
                      </tr>

                      <tr>
                        <td class="bold">Unterzeichner:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            id="UNTERZEICHNER"
                            formControlName="UNTERZEICHNER"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="" />
                        </td>
                      </tr>

                      <tr>
                        <td class="bold">Bearbeiter:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            id="BEARBEITER"
                            formControlName="BEARBEITER"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="" />
                        </td>
                      </tr>

                      <tr>
                        <td class="bold">Beweismittel (Bilder) mitsenden:</td>
                        <td>
                          <label style="display: flex; align-items: center; gap: 8px; cursor: pointer;">
                            <input
                              type="checkbox"
                              [checked]="frmVSettings.get('VSTV_BEWEISMITTEL_EXPORT')?.value === '1'"
                              (change)="frmVSettings.patchValue({ VSTV_BEWEISMITTEL_EXPORT: $any($event.target).checked ? '1' : '0' }); frmVSettings.markAsDirty()"
                              style="width: 18px; height: 18px;" />
                            Beweismittel-Kennung im VSTV-Export mitsenden
                          </label>
                          <small class="text-muted">
                            Wenn aktiviert, werden <em>beweismittelkey</em> und <em>anzahlbeweismittel</em> bei vorhandenen
                            Bildern in den VSTV-Export (XML) geschrieben.
                          </small>
                        </td>
                      </tr>
                    </table>
                    <button mat-raised-button (click)="saveSettings()" color="primary">Speichern</button>
                  </form>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="VSTV Freitexte">
            <div class="container-fluid p-1">
              <div class="row w-100 m-0">
                <div class="col-sm-12 col-md-4 p-0">
                  <h2>VSTV Freitexte</h2>
                  <small>Sie können Texte definieren, welche als Textbaustein vor und nach einem Tatbestand-Freitext zusätzlich übermittelt werden.</small>
                </div>
                <div class="col-sm-12 col-md-7 offset-md-1 p-1">
                  <form class="mt-3" name="frmVSTVZusatztexte" [formGroup]="frmVSettings">
                    <!-- Vor Textbaustein -->
                    <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 4px;">
                      <label class="bold" style="margin: 0; white-space: nowrap;">Vor Textbaustein</label>
                      <select style="font-size: 11px; padding: 2px 6px; border: 1px solid #d1d5db; border-radius: 4px;"
                        (change)="insertSettingsPlaceholder('VOR', $event)">
                        <option value="">Platzhalter einfügen...</option>
                        <option *ngFor="let ph of settingsPlaceholders" [value]="ph">{{ ph }}</option>
                      </select>
                    </div>
                    <textarea
                      #vorTextarea
                      class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                      style="min-height: 120px"
                      formControlName="VOR_TEXTBAUSTEIN"
                      placeholder=""></textarea>

                    <!-- Nach Textbaustein -->
                    <div style="display: flex; align-items: center; gap: 10px; margin-top: 16px; margin-bottom: 4px;">
                      <label class="bold" style="margin: 0; white-space: nowrap;">Nach Textbaustein</label>
                      <select style="font-size: 11px; padding: 2px 6px; border: 1px solid #d1d5db; border-radius: 4px;"
                        (change)="insertSettingsPlaceholder('NACH', $event)">
                        <option value="">Platzhalter einfügen...</option>
                        <option *ngFor="let ph of settingsPlaceholders" [value]="ph">{{ ph }}</option>
                      </select>
                    </div>
                    <textarea
                      #nachTextarea
                      class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                      style="min-height: 120px"
                      formControlName="NACH_TEXTBAUSTEIN"
                      placeholder=""></textarea>
                    <button mat-raised-button (click)="saveSettings()" color="primary">Speichern</button>
                  </form>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="Akt per Mail">
            <div class="container-fluid p-1">
              <div class="row w-100 m-0">
                <div class="col-sm-12 col-md-4 p-0">
                  <h2>Akt per Mail</h2>
                  <small>Legen Sie die Standardwerte fest, die beim Versenden eines Akts per E-Mail vorausgefüllt werden. Diese können beim Senden noch angepasst werden.</small>
                </div>
                <div class="col-sm-12 col-md-7 offset-md-1 p-1">
                  <form class="mt-3" name="frmMailSettings" [formGroup]="frmVSettings">
                    <table class="table table-striped table-sm">
                      <tr>
                        <td class="bold">Standard An (To):</td>
                        <td>
                          <input
                            type="email"
                            class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            formControlName="MAIL_DEFAULT_TO"
                            placeholder="empfaenger@beispiel.at" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">Standard BCC:</td>
                        <td>
                          <input
                            type="email"
                            class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            formControlName="MAIL_DEFAULT_BCC"
                            placeholder="kopie@beispiel.at" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">Standard Betreff:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            formControlName="MAIL_DEFAULT_SUBJECT"
                            placeholder="Akt ##Aktenzahl## - ##Kennzeichen##" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold" style="vertical-align: top; padding-top: 10px;">Standard Inhalt:</td>
                        <td>
                          <textarea
                            class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            style="min-height: 180px"
                            formControlName="MAIL_DEFAULT_BODY"
                            placeholder="Sehr geehrte Damen und Herren, ..."></textarea>
                        </td>
                      </tr>
                    </table>
                    <div style="font-size: 11px; color: #6b7280; margin-bottom: 12px;">
                      <strong>Verfügbare Platzhalter:</strong>
                      ##Aktenzahl##, ##Kennzeichen##, ##Dienstnehmer_Name##, ##Dienst_Nummer##,
                      ##Tatdatum_von##, ##Tatzeit_von##, ##Strasse##, ##Hausnummer##
                    </div>
                    <button mat-raised-button (click)="saveSettings()" color="primary">Speichern</button>
                  </form>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="Whitelist">
            <div class="container-fluid p-1">
              <div class="row w-100 m-0">
                <div class="col-sm-12 col-md-4 p-0">
                  <h2>Whitelist</h2>
                  <small>Einstellungen für die Kennzeichen-Whitelist. Freigestellte Kennzeichen werden bei Transfer, Überfällig-Markierung und VSTV-Export automatisch storniert.</small>
                </div>
                <div class="col-sm-12 col-md-7 offset-md-1 p-1">
                  <form class="mt-3" name="frmWhitelistSettings" [formGroup]="frmVSettings">
                    <table class="table table-striped table-sm">
                      <tr>
                        <td class="bold" style="vertical-align: top; padding-top: 10px;">Standard Storno-Grund:</td>
                        <td>
                          <textarea
                            class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            style="min-height: 80px"
                            formControlName="WHITELIST_DEFAULT_REASON"
                            placeholder="Kennzeichen freigestellt (Whitelist)"></textarea>
                          <small class="text-gray-500">Dieser Text wird in die "Interne Notizen" geschrieben, wenn ein Mandat automatisch storniert wird.</small>
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">Mobile App benachrichtigen:</td>
                        <td>
                          <label style="display: flex; align-items: center; gap: 8px; cursor: pointer;">
                            <input
                              type="checkbox"
                              [checked]="frmVSettings.get('WHITELIST_NOTIFY_MOBILE')?.value === '1'"
                              (change)="frmVSettings.patchValue({ WHITELIST_NOTIFY_MOBILE: $any($event.target).checked ? '1' : '0' })"
                              style="width: 18px; height: 18px;" />
                            Aktiviert
                          </label>
                          <small class="text-gray-500">Wenn aktiviert, wird dem Überwachungsorgan beim Erfassen eines freigestellten Kennzeichens sofort eine Meldung angezeigt.</small>
                        </td>
                      </tr>
                      <tr>
                        <td class="bold" style="vertical-align: top; padding-top: 10px;">Mobile App Meldung:</td>
                        <td>
                          <textarea
                            class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            style="min-height: 60px"
                            formControlName="WHITELIST_MOBILE_MESSAGE"
                            placeholder="Dieses Kennzeichen ist freigestellt. Bitte kein Mandat erstellen."></textarea>
                          <small class="text-gray-500">Diese Nachricht wird der Mobile App angezeigt, wenn ein freigestelltes Kennzeichen erfasst wird.</small>
                        </td>
                      </tr>
                    </table>
                    <button mat-raised-button (click)="saveSettings()" color="primary">Speichern</button>
                  </form>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab *ngIf="showBulkImport" label="Bulk-Import">
            <div class="container-fluid p-1">
              <div class="row w-100 m-0">
                <div class="col-sm-12 col-md-4 p-0">
                  <h2>Bulk-Import (Barcode)</h2>
                  <small>Standardwerte, die beim Scannen eines Aktenzeichens auf der Bulk-Import-Seite gesetzt werden. Sie ersetzen die "Barcode"-Einstellungen der alten C#-Anwendung.</small>
                </div>
                <div class="col-sm-12 col-md-7 offset-md-1 p-1">
                  <form class="mt-3" name="frmBulkSettings" [formGroup]="frmVSettings">
                    <table class="table table-striped table-sm">
                      <tr>
                        <td class="bold">Strafe (&euro;):</td>
                        <td>
                          <input
                            type="number"
                            class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            formControlName="BULK_STRAFE"
                            placeholder="20" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">Kennzeichen-Land:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            formControlName="BULK_LAND"
                            placeholder="A" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">Kennzeichen-Bezirk:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            formControlName="BULK_BEZIRK"
                            placeholder="(optional)" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">Zone:</td>
                        <td>
                          <input
                            type="number"
                            class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            formControlName="BULK_ZONE"
                            placeholder="0" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">Fahrzeugart:</td>
                        <td>
                          <input
                            type="number"
                            class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            formControlName="BULK_FAHRZEUGART"
                            placeholder="0" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold" style="vertical-align: top; padding-top: 10px;">Bearbeiter:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            formControlName="BULK_BEARBEITER"
                            placeholder="(leer = angemeldeter Dienstnehmer)" />
                          <small class="text-gray-500">Leer lassen, damit der angemeldete Dienstnehmer als Bearbeiter eingetragen wird.</small>
                        </td>
                      </tr>
                    </table>
                    <button mat-raised-button (click)="saveSettings()" color="primary">Speichern</button>
                  </form>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab *ngIf="showZahlungsabgleich" label="Berichte">
            <div class="container-fluid p-1">
              <div class="row w-100 m-0">
                <div class="col-sm-12 col-md-4 p-0">
                  <h2>Berichte</h2>
                  <small>Kopf- und Fußzeilen-Informationen für die Zahlungsabgleich-Berichte (PDF / Druck). Logo, Firmendaten und Druckoptionen werden im Bericht verwendet.</small>
                </div>
                <div class="col-sm-12 col-md-7 offset-md-1 p-1">
                  <form class="mt-3" name="frmReportSettings" [formGroup]="frmVSettings">
                    <table class="table table-striped table-sm">
                      <tr>
                        <td class="bold">Firma / Gemeinde:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            formControlName="REPORT_COMPANY_NAME"
                            placeholder="z.B. Stadtgemeinde Musterstadt" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold" style="vertical-align: top; padding-top: 10px;">Adresse:</td>
                        <td>
                          <textarea
                            rows="3"
                            class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            formControlName="REPORT_ADDRESS"
                            placeholder="Straße, PLZ Ort"></textarea>
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">IBAN:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            formControlName="REPORT_IBAN"
                            placeholder="AT00 0000 0000 0000 0000" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold" style="vertical-align: top; padding-top: 10px;">Fußzeilentext:</td>
                        <td>
                          <textarea
                            rows="2"
                            class="form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            formControlName="REPORT_FOOTER_TEXT"
                            placeholder="Optionaler Text in der Fußzeile"></textarea>
                        </td>
                      </tr>
                      <tr>
                        <td class="bold" style="vertical-align: top; padding-top: 10px;">Logo:</td>
                        <td>
                          <file-pond
                            #reportLogoPond
                            [options]="reportLogoPondOptions"
                            [files]="reportLogoPondFiles">
                          </file-pond>

                          <div *ngIf="reportLogoPreviewUrl" class="mt-2">
                            <img [src]="reportLogoPreviewUrl" alt="Logo Vorschau" style="max-height: 70px; max-width: 200px; border: 1px solid #ddd; padding: 4px;" />
                          </div>

                          <div *ngIf="frmVSettings.get('REPORT_LOGO')?.value" class="mt-2 text-gray-600" style="font-size: 12px;">
                            Logo hinterlegt: {{ frmVSettings.get('REPORT_LOGO')?.value }}
                            <button type="button" mat-button color="warn" (click)="removeReportLogo()">Logo entfernen</button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">Druckdatum anzeigen:</td>
                        <td>
                          <input type="checkbox" formControlName="REPORT_PRINT_DATE" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">Seitenzahlen anzeigen:</td>
                        <td>
                          <input type="checkbox" formControlName="REPORT_PRINT_PAGENUMBERS" />
                        </td>
                      </tr>
                      <tr>
                        <td class="bold">Gesamtsumme anzeigen:</td>
                        <td>
                          <input type="checkbox" formControlName="REPORT_PRINT_TOTALSUM" />
                        </td>
                      </tr>
                    </table>
                    <button mat-raised-button (click)="saveSettings()" color="primary">Speichern</button>
                  </form>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="Mobile Parking">
            <div class="container-fluid p-3">
              <div class="row w-100 m-0">
                <div class="col-sm-12 col-md-4 p-0">
                  <h2>Mobile Parking</h2>
                  <small>
                    Anbindung an externe Park-Apps (HandyParken, SmartParking, EasyPark).
                  </small>
                </div>
                <div class="col-sm-12 col-md-7 offset-md-1 p-1">
                  <form class="mt-3" [formGroup]="frmVSettings" autocomplete="off">
                    <table class="table table-striped table-sm">
                      <tr>
                        <td class="bold" style="width: 200px; vertical-align: middle;">Aktiviert:</td>
                        <td>
                          <mat-slide-toggle color="primary" formControlName="MOBILE_PARKING_ENABLED">
                            {{ mobileParkingEnabled ? 'Aktiv' : 'Inaktiv' }}
                          </mat-slide-toggle>
                        </td>
                      </tr>
                      <tr *ngIf="mobileParkingEnabled">
                        <td class="bold">Anbieter:</td>
                        <td>
                          <select
                            formControlName="MOBILE_PARKING_PROVIDER"
                            autocomplete="off"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full max-w-md p-2.5">
                            <option *ngFor="let p of mobileParkingProviders" [value]="p.value">
                              {{ p.label }}
                            </option>
                          </select>
                        </td>
                      </tr>
                      <tr *ngIf="mobileParkingEnabled">
                        <td class="bold">Schnittstellen-Kennung:</td>
                        <td>
                          <input
                            type="text"
                            formControlName="MOBILE_PARKING_API_KEY"
                            name="mp-schnittstellen-kennung"
                            autocomplete="off"
                            autocapitalize="off"
                            autocorrect="off"
                            spellcheck="false"
                            readonly
                            (focus)="enableMobileParkingField($event)"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            placeholder="Kennung vom Park-App-Anbieter" />
                        </td>
                      </tr>
                      <tr *ngIf="mobileParkingEnabled">
                        <td class="bold">Geheimer Anbieter-Code:</td>
                        <td>
                          <input
                            type="text"
                            formControlName="MOBILE_PARKING_SECURITY_TOKEN"
                            name="mp-anbieter-geheimcode"
                            autocomplete="off"
                            autocapitalize="off"
                            autocorrect="off"
                            spellcheck="false"
                            readonly
                            (focus)="enableMobileParkingField($event)"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 font-mono"
                            placeholder="Geheimcode vom Park-App-Anbieter" />
                        </td>
                      </tr>
                    </table>
                    <button
                      mat-raised-button
                      color="primary"
                      type="button"
                      (click)="saveMobileParkingSettings()"
                      [disabled]="!isSuperuser">
                      Speichern
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </mat-tab>

          <!-- Systeminformation Tab -->
          <mat-tab label="Systeminformation">
            <div class="container-fluid p-3">
              <div *ngIf="loadingSystemInfo" class="mt-4">
                <p>Laden...</p>
              </div>

              <div *ngIf="!loadingSystemInfo && systemInfo" style="font-size: 11px; line-height: 1.4;">
                <!-- Server Info -->
                <h3 style="font-size: 12px; font-weight: 600; margin: 12px 0 4px 0; color: #374151; text-transform: uppercase; letter-spacing: 0.5px;">Server</h3>
                <table class="table table-striped table-sm" style="max-width: 500px; font-size: 11px;">
                  <tbody>
                    <tr><td class="bold" style="width: 150px; padding: 2px 6px;">PHP Version</td><td style="padding: 2px 6px;">{{ systemInfo.server?.php_version }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Server Software</td><td style="padding: 2px 6px;">{{ systemInfo.server?.server_software }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Zeitzone</td><td style="padding: 2px 6px;">{{ systemInfo.server?.timezone }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Betriebssystem</td><td style="padding: 2px 6px;">{{ systemInfo.server?.os }}</td></tr>
                  </tbody>
                </table>

                <!-- Database Info -->
                <h3 style="font-size: 12px; font-weight: 600; margin: 14px 0 4px 0; color: #374151; text-transform: uppercase; letter-spacing: 0.5px;">Datenbank</h3>
                <table class="table table-striped table-sm" style="max-width: 500px; font-size: 11px;">
                  <tbody>
                    <tr><td class="bold" style="width: 150px; padding: 2px 6px;">Treiber</td><td style="padding: 2px 6px;">{{ systemInfo.database?.driver }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Host</td><td style="padding: 2px 6px;">{{ systemInfo.database?.host }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Datenbank</td><td style="padding: 2px 6px;">{{ systemInfo.database?.database }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">MySQL Version</td><td style="padding: 2px 6px;">{{ systemInfo.database?.mysql_version }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Zeichensatz</td><td style="padding: 2px 6px;">{{ systemInfo.database?.charset }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Sortierung</td><td style="padding: 2px 6px;">{{ systemInfo.database?.collation }}</td></tr>
                  </tbody>
                </table>

                <!-- API Info -->
                <h3 style="font-size: 12px; font-weight: 600; margin: 14px 0 4px 0; color: #374151; text-transform: uppercase; letter-spacing: 0.5px;">API Konfiguration</h3>
                <table class="table table-striped table-sm" style="max-width: 700px; font-size: 11px;">
                  <tbody>
                    <tr><td class="bold" style="width: 150px; padding: 2px 6px;">WebApp ID</td><td style="padding: 2px 6px;">{{ systemInfo.api?.webapp_id }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Gemeinde Key</td><td style="padding: 2px 6px;">{{ systemInfo.api?.gemeinde_key }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Zugriffspunkt</td><td style="padding: 2px 6px;">{{ systemInfo.api?.accesspoint }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">API Base URL</td><td style="padding: 2px 6px;"><code style="font-size: 11px;">{{ systemInfo.api?.api_base_url }}</code></td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">API Request URL</td><td style="padding: 2px 6px;"><code style="font-size: 11px;">{{ systemInfo.api?.api_request_url }}</code></td></tr>
                  </tbody>
                </table>

                <!-- VSTV Config -->
                <h3 style="font-size: 12px; font-weight: 600; margin: 14px 0 4px 0; color: #374151; text-transform: uppercase; letter-spacing: 0.5px;">VSTV Konfiguration</h3>
                <table class="table table-striped table-sm" style="max-width: 500px; font-size: 11px;">
                  <tbody>
                    <tr><td class="bold" style="width: 150px; padding: 2px 6px;">Empfänger</td><td style="padding: 2px 6px;">{{ systemInfo.vstv?.empfanger }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Sender</td><td style="padding: 2px 6px;">{{ systemInfo.vstv?.sender }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Gemeinde</td><td style="padding: 2px 6px;">{{ systemInfo.vstv?.gemeinde }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Tatortart</td><td style="padding: 2px 6px;">{{ systemInfo.vstv?.tatortart }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Landeskennzeichen</td><td style="padding: 2px 6px;">{{ systemInfo.vstv?.landeskennzeichen }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Straßenerhalter</td><td style="padding: 2px 6px;">{{ systemInfo.vstv?.sonstiger_strassenerhalter }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Wahrnehmung</td><td style="padding: 2px 6px;">{{ systemInfo.vstv?.wahrnehmung }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">VSTV Präfix</td><td style="padding: 2px 6px;">{{ systemInfo.vstv?.vstv_pre_nummer }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Unterzeichner</td><td style="padding: 2px 6px;">{{ systemInfo.vstv?.unterzeichner }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Bearbeiter</td><td style="padding: 2px 6px;">{{ systemInfo.vstv?.bearbeiter }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Tage zur Anzeige</td><td style="padding: 2px 6px;">{{ systemInfo.vstv?.tage_zur_anzeige }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Tage zur BOM</td><td style="padding: 2px 6px;">{{ systemInfo.vstv?.tage_zur_bom }}</td></tr>
                  </tbody>
                </table>

                <!-- Storage Info -->
                <h3 style="font-size: 12px; font-weight: 600; margin: 14px 0 4px 0; color: #374151; text-transform: uppercase; letter-spacing: 0.5px;">Datenspeicher</h3>
                <table class="table table-striped table-sm" style="max-width: 700px; font-size: 11px;">
                  <tbody>
                    <tr><td class="bold" style="width: 150px; padding: 2px 6px;">Bilddatenbank</td><td style="padding: 2px 6px;"><code style="font-size: 11px;">{{ systemInfo.storage?.bilddatenbank }}</code></td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">VSTV Export</td><td style="padding: 2px 6px;"><code style="font-size: 11px;">{{ systemInfo.storage?.vstv_export }}</code></td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">VSTV 2025 Export</td><td style="padding: 2px 6px;"><code style="font-size: 11px;">{{ systemInfo.storage?.vstv25_export }}</code></td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Webstore</td><td style="padding: 2px 6px;"><code style="font-size: 11px;">{{ systemInfo.storage?.webstore }}</code></td></tr>
                  </tbody>
                </table>

                <!-- Mail Info -->
                <h3 style="font-size: 12px; font-weight: 600; margin: 14px 0 4px 0; color: #374151; text-transform: uppercase; letter-spacing: 0.5px;">E-Mail Konfiguration</h3>
                <table class="table table-striped table-sm" style="max-width: 500px; font-size: 11px;">
                  <tbody>
                    <tr><td class="bold" style="width: 150px; padding: 2px 6px;">SMTP Host</td><td style="padding: 2px 6px;">{{ systemInfo.mail?.host }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Port</td><td style="padding: 2px 6px;">{{ systemInfo.mail?.port }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Typ</td><td style="padding: 2px 6px;">{{ systemInfo.mail?.type }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Absender E-Mail</td><td style="padding: 2px 6px;">{{ systemInfo.mail?.sender_email }}</td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Absender Name</td><td style="padding: 2px 6px;">{{ systemInfo.mail?.sender_name }}</td></tr>
                  </tbody>
                </table>

                <!-- Dienstnehmer List -->
                <h3 style="font-size: 12px; font-weight: 600; margin: 14px 0 4px 0; color: #374151; text-transform: uppercase; letter-spacing: 0.5px;">Dienstnehmer</h3>
                <table class="table table-striped table-sm" style="max-width: 700px; font-size: 11px;">
                  <thead>
                    <tr>
                      <th style="padding: 2px 6px;">Name</th>
                      <th style="padding: 2px 6px;">Dienstnr.</th>
                      <th style="padding: 2px 6px;">DN STVO</th>
                      <th style="padding: 2px 6px;">Aktiv</th>
                      <th style="padding: 2px 6px;">Gruppe</th>
                      <th style="padding: 2px 6px;">Sachbereich</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let dn of systemInfo.dienstnehmer">
                      <td style="padding: 2px 6px;">{{ dn.name }}</td>
                      <td style="padding: 2px 6px;">{{ dn.dienstnummer }}</td>
                      <td style="padding: 2px 6px;">{{ dn.dienstnummer_stvo }}</td>
                      <td style="padding: 2px 6px; color: #16a34a; font-weight: 600;">Aktiv</td>
                      <td style="padding: 2px 6px;">{{ dn.benutzergruppe }}</td>
                      <td style="padding: 2px 6px;">{{ dn.sachbereich }}</td>
                    </tr>
                  </tbody>
                </table>

                <!-- Security Info -->
                <h3 style="font-size: 12px; font-weight: 600; margin: 14px 0 4px 0; color: #374151; text-transform: uppercase; letter-spacing: 0.5px;">Sicherheit</h3>
                <table class="table table-striped table-sm" style="max-width: 500px; font-size: 11px;">
                  <tbody>
                    <tr><td class="bold" style="width: 150px; padding: 2px 6px;">API Authentifizierung</td><td style="padding: 2px 6px;">JWT Token-basiert gesichert <span style="color: #16a34a; font-weight: 600;">&#10003;</span></td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">API Gateway</td><td style="padding: 2px 6px;">IP-Whitelist (Gate-IP) aktiv <span style="color: #16a34a; font-weight: 600;">&#10003;</span></td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Desktop Zugriff</td><td style="padding: 2px 6px;">IP-basierte Zugriffskontrolle <span style="color: #16a34a; font-weight: 600;">&#10003;</span></td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Firewall</td><td style="padding: 2px 6px;">Aktiv und konfiguriert <span style="color: #16a34a; font-weight: 600;">&#10003;</span></td></tr>
                    <tr><td class="bold" style="padding: 2px 6px;">Datenübertragung</td><td style="padding: 2px 6px;">SSL/TLS verschlüsselt <span style="color: #16a34a; font-weight: 600;">&#10003;</span></td></tr>
                  </tbody>
                </table>

                <!-- Refresh button -->
                <button mat-raised-button color="primary" class="mt-3" style="font-size: 11px;" (click)="loadSystemInfo()">
                  Aktualisieren
                </button>
              </div>

              <div *ngIf="!loadingSystemInfo && !systemInfo" class="mt-4">
                <p>Systeminformationen konnten nicht geladen werden.</p>
                <button mat-raised-button color="primary" class="mt-2" (click)="loadSystemInfo()">
                  Erneut versuchen
                </button>
              </div>
            </div>
          </mat-tab>

        </mat-tab-group>
      </mat-card-content>
    </mat-card>
  </div>
</div>
